import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { AmentiesInfo, RoomsInfo } from '../rooms-info';
import { CustomCarousel } from '../../carousel/carousel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './room.scss';
import { RoomDetailInfoModal } from '../room-detail-info-modal/room-detail-info-modal';
import { useNavigate } from 'react-router-dom';

export function RoomCard(){

    const navigate = useNavigate();
    const [roomsInfo, setRoomsInfo] = useState(RoomsInfo);
    const amentiesList = AmentiesInfo;

    function displayDetailInfoModel(roomInfo){
        return (
            <RoomDetailInfoModal show={roomInfo.show} roomInfo={roomInfo} handleClose={handleClose}/>
        )
    }

    function handleClose(roomInfo){
        setRoomsInfo(roomsInfo.map(
            room => {
                if(room.type === roomInfo.type){
                    return {
                        ...room, 
                        show: false
                    }
                }
                return room;
            }
        ))
    }

    function displayRoomInfoModal(roomInfo){
        setRoomsInfo(roomsInfo.map(
            room => {
                if(room.type === roomInfo.type){
                    return {
                        ...room, 
                        show: true
                    }
                }
                return room;
            }
        ))
    }

    return (
        roomsInfo.map(
            roomInfo =>
                
                <Card className='room-card'>
                    <Card.Header><CustomCarousel imagesURL={roomInfo.imagesURL}/> </Card.Header>
                    <Card.Body>
                        <Card.Title>{roomInfo.label}</Card.Title>
                        <Card.Text>
                            <RoomInfoChip info={roomInfo}/>
                            <p>Main amenities</p>
                            <Amenties amentiesList={amentiesList}/>
                            <Button variant='link' onClick={() => displayRoomInfoModal(roomInfo)} className='read-more'>Read More<img style={{display: 'inline'}} src='arrow.svg' alt='' loading="lazy" decoding="async" /></Button>
                        </Card.Text>
                        <Button variant="primary" className='book-now' onClick={() => navigate('/book-now')}>Book Now</Button>
                    </Card.Body>
                    {
                        displayDetailInfoModel(roomInfo)
                    }
                </Card>
                
        )
    )
}

export function RoomInfoChip({info}){
    return (
        <div className='room-info-chips'>
            <ul>
                <li className='room-info-chip'>{`${info.size} ft`}<sup>2</sup></li>
                <li className='room-info-chip'>{`${info.noOfAdults} adults`}</li>
                <li className='room-info-chip'>{`${info.noOfKids} kids`}</li>
                <li className='room-info-chip'>{`${info.noOfKingBeds} King bed(s)`}</li>
            </ul>
        </div>
    )
}

export function Amenties({amentiesList}){
    return(
        <div className='main-amenties-list'>
            <ul className='amenties-list'>
                {
                    amentiesList.map(
                        amenty => {
                            return <li className='amenty' key={amenty.id}>
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip id={amenty.id}>{amenty.label}</Tooltip>}
                                >
                                    <img className='amenty-icon' src={amenty.imageURL} alt={amenty.altText} loading="lazy" decoding="async"></img>
                                </OverlayTrigger>
                            </li>
                        }
                    )
                }
            </ul>
        </div>
    )
}